import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, formValueSelector } from 'redux-form/immutable';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import { showDialog, hideDialog } from '../../redux/actions/dialogs';
import { fetchSettingsRoutine } from '../../redux/routines';
import { renderSlider } from '../../utils/reduxforms';
import Dashboard from '../Dashboard';

import styles from './styles';
import { CREDIT_CARD_DIALOG } from '../../redux/constants/dialogs';

class Settings extends Component {
  static propTypes = {
    settings: PropTypes.object.isRequired,
    fetchSettings: PropTypes.func.isRequired,

    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,

    handleSubmit: PropTypes.func.isRequired,
  };

  componentWillMount() {
    this.props.fetchSettings();
  }

  render() {
    const { settings, handleSubmit, retention } = this.props;
    return (
      <Dashboard title="Settings">
        <form onSubmit={handleSubmit}>
          <Paper style={styles.paymentContainer}>
            <h3>Account</h3>
            <div style={styles.tableContainer}>
              <table style={styles.table}>
                <tr>
                  <td width="200px">Plan</td>
                  <td width="500px">
                    {settings.account.type}
                    <Button
                      variant="contained"
                      type="button"
                      color="secondary"
                      style={styles.upgrade}
                      onClick={() => this.props.showDialog(CREDIT_CARD_DIALOG)}>Upgrade</Button>
                  </td>
                </tr>
                <tr>
                  <td>Task Limit</td>
                  <td>{settings.account.taskLimit}</td>
                </tr>
                <tr>
                  <td>User Limit</td>
                  <td>{settings.account.userLimit}</td>
                </tr>
                <tr>
                  <td>Data Retention Period</td>
                  <td style={styles.slider}>
                    <Field
                      name="retention"
                      component={renderSlider}
                      min={1}
                      max={12}
                      step={1}
                    />
                  </td>
                  <td>
                    { retention } months
                  </td>
                </tr>
              </table>
            </div>
          </Paper>

        </form>
      </Dashboard>
    );
  }
}

const form = reduxForm({
  form: 'settings',  // a unique identifier for this form
  onSubmit: (values, dispatch) => {
    console.log('vals', values);
  },
})(Settings);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchSettings: fetchSettingsRoutine.trigger,
    showDialog,
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state) {
  const selector = formValueSelector('settings');

  return {
    settings: state.get('accounts').get('settings').toJS(),
    retention: selector(state, 'retention'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Settings/index.js